var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMenuKtree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 1.5C5.27615 1.5 5.5 1.72386 5.5 2V4C5.5 4.27614 5.27615 4.5 5 4.5H4V5.5H6.5V5C6.5 4.72386 6.72385 4.5 7 4.5H10C10.2761 4.5 10.5 4.72386 10.5 5V7C10.5 7.27615 10.2761 7.5 10 7.5H7C6.72385 7.5 6.5 7.27615 6.5 7V6.5H4V9.5H6.5V9C6.5 8.72385 6.72385 8.5 7 8.5H10C10.2761 8.5 10.5 8.72385 10.5 9V11C10.5 11.2761 10.2761 11.5 10 11.5H7C6.72385 11.5 6.5 11.2761 6.5 11V10.5H3.5C3.22386 10.5 3 10.2761 3 10V4.5H2C1.72386 4.5 1.5 4.27614 1.5 4V2C1.5 1.72386 1.72386 1.5 2 1.5H5ZM9.5 9.5H7.5V10.5H9.5V9.5ZM9.5 5.5H7.5V6.5H9.5V5.5ZM4.5 2.5H2.5V3.5H4.5V2.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenuKtree);
export default __webpack_public_path__ + "static/media/icon-menu-ktree.b436f94c09392460d006877456026f72.svg";
export { ForwardRef as ReactComponent };